import { useState } from 'react';
import '../../css/NewUserWCEventModal.css';
import axiosClient from '../../utils/axiosClient';

const NewUserWCEventModal = ({ isOpen, onClose }) => {
	const rewardId = process.env.REACT_APP_EVENT_REWARD_ID;
	const campaignId = process.env.REACT_APP_WELCOME_EVENT_CAMPAIGN_ID_MY;
	const [isLoading, setIsLoading] = useState(false);
	const [claimStatus, setIsClaimStatus] = useState();
	const [disableButton, setDisableButton] = useState(false);

	const claimEventReward = async () => {
		try {
			setDisableButton(true);
			setIsLoading(true);
			await axiosClient
				.post(
					'/campaigns/entries',
					{
						campaignId,
						selectedRewardIds: [rewardId],
						type: 'GENERAL',
					},
					{
						headers: {
							...axiosClient.defaults.headers,
							'Accept-Version': '2.0.0',
						},
					}
				)
				.then((response) => {
					if (response.data.statusCode !== 400) {
						setIsClaimStatus('Reward Claimed!');
						setTimeout(onClose, 1000);
						setIsLoading(false);
					} else setIsClaimStatus('Reward Already Claimed!');
				});
		} catch (error) {
			setIsClaimStatus('Failed to claim reward');
			setIsLoading(false);
			console.error(error);
		}
	};

	if (!isOpen) return null;

	return (
		<div className="welcome-modal-overlay">
			<div className="welcome-modal-backdrop" />

			<div className="welcome-modal-content">
				<div className="welcome-top-section">
					<button
						onClick={onClose}
						className="welcome-close-button"
						aria-label="Close"
					>
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.923077 12L0 11.0769L5.07692 6L0 0.923077L0.923077 0L6 5.07692L11.0769 0L12 0.923077L6.92308 6L12 11.0769L11.0769 12L6 6.92308L0.923077 12Z"
								fill="black"
							/>
						</svg>
					</button>

					<img
						src="/spin-event/flag-banner-left.png"
						alt="Left banner"
						className="welcome-decoration-flag-left"
					/>
					<img
						src="/spin-event/flag-banner-right.png"
						alt="Right banner"
						className="welcome-decoration-flag-right"
					/>
					<img
						src="/spin-event/confetti-1.png"
						alt="Confetti"
						className="welcome-decoration-confetti"
					/>
					<img
						src="/spin-event/confetti-2.png"
						alt="Confetti"
						className="welcome-decoration-confetti"
					/>

					<div className="welcome-content-wrapper">
						<img
							src="/spin-event/giftbox-80-points.png"
							alt="Gift box with 80 points"
							className="welcome-giftbox-image"
						/>
						<h2 className="welcome-title">You're In!</h2>
						<div className="welcome-text-container">
							<p className="welcome-text">
								Welcome to <b>Haleon Rewards!</b>
							</p>
							<p className="welcome-text">
								To get you started, here's a <b>welcome gift of</b>
							</p>
						</div>
					</div>
				</div>

				<div className="welcome-bottom-section">
					<h2 className="welcome-points-title">80 Points!</h2>

					<button
						disabled={isLoading}
						onClick={disableButton ? null : claimEventReward}
						className="welcome-claim-button"
					>
						{claimStatus
							? claimStatus
							: isLoading
							? 'Claiming...'
							: 'Claim & Continue'}
					</button>
					<div className="welcome-terms-container">
						<p className="welcome-terms-text">
							One-time per user. Auto-credited to your points balance.
						</p>
						<p
							onClick={() => window.open('https://www.google.com', '_blank')}
							className="welcome-terms-link"
						>
							T&Cs apply
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NewUserWCEventModal;
